import React from 'react';
import PropTypes from 'prop-types';
import deburr from 'lodash/deburr';
import Autosuggest from 'react-autosuggest';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import { MenuItem } from 'material-ui';
import { TextField } from 'material-ui';
import { Paper } from 'material-ui';
import { withStyles } from 'material-ui';
import SearchIcon from 'material-ui-icons/Search';
import { getFlagImage } from '../components/MarketAPI';


function renderInputComponent(inputProps) {
    let { classes, t, selection, inputRef = () => { }, ref, ...other } = inputProps;
    return (
        <div>
            <div>
                {selection && selection.code ?
                    <img title={selection.label} width='24'
                        alt={selection.label} src={getFlagImage(selection.code)}
                        align="middle" /> : <img width='24' alt='' />
                }
            </div>
            <TextField
                InputProps={{
                    inputRef: node => {
                        ref(node);
                        inputRef(node);
                    },
                    classes: {
                        input: classes.input,
                    },
                    endAdornment: <SearchIcon className={classes.keyboardIcon} />,
                }}
                {...other}
            />
        </div>
    );
}

function renderSuggestion(suggestion, { query, isHighlighted }) {
    const matches = match(suggestion.label, query);
    const parts = parse(suggestion.label, matches);
    return (
        <MenuItem selected={isHighlighted} component="div">
            <img alt={suggestion.label} style={{ marginRight: '4px' }} width='24'
                src={getFlagImage(suggestion.code)} />
            {parts.map((part, index) =>
                part.highlight ? (
                    <span key={String(index)} style={{ fontWeight: 500 }}>
                        {part.text}
                    </span>
                ) : (
                    <strong key={String(index)} style={{ fontWeight: 300 }}>
                        {part.text}
                    </strong>
                ),
            )}
        </MenuItem>
    );
}

function getSuggestions(value, dataProvider) {
    const inputValue = deburr(value.trim()).toLowerCase();
    const inputLength = inputValue.length;
    let count = 0;

    return inputLength === 0
        ? []
        : dataProvider.filter(suggestion => {
            const keep =
                count < 10 && deburr(suggestion.label.slice(0, inputLength)).toLowerCase() === inputValue;

            if (keep) {
                count += 1;
            }

            return keep;
        });
}

function getSuggestionValue(suggestion) {
    return suggestion.label;
}

const styles = theme => ({
    container: {
        position: 'relative',
    },
    suggestionsContainerOpen: {
        position: 'relative',
        zIndex: 1000,
        marginTop: 0,
        left: 0,
        right: 0,
    },
    suggestion: {
        display: 'block',
    },
    suggestionsList: {
        margin: 0,
        padding: 0,
        listStyleType: 'none',
    }
});

class IntegrationAutosuggest extends React.Component {
    state = {
        single: '',
        popper: '',
        selectedSuggestion: null,
        suggestions: [],
        dataProvider: []
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.dataProvider && nextProps.dataProvider != null) {
            let selc = [];
            if (this.state.selectedValue) {
                selc = nextProps.dataProvider.filter(it => it.code === this.state.selectedValue);
            }
            selc = selc && selc.length > 0 ? selc[0] : null;
            this.setState({
                dataProvider: nextProps.dataProvider,
                popper: selc ? selc.label : '',
                selectedSuggestion: selc,
            });
        }
        if (nextProps.selectedValue) {
            let selc = [];
            if (nextProps.selectedValue) {
                selc = nextProps.dataProvider.filter(it => it.code === nextProps.selectedValue);
            }
            selc = selc && selc.length > 0 ? selc[0] : null;
            this.setState({
                popper: selc ? selc.label : '',
                selectedSuggestion: selc,
                selectedValue: nextProps.selectedValue
            });
        }
    }

    updateSelectionDataProvider = () => {

    }

    handleSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            suggestions: getSuggestions(value, this.state.dataProvider),
        });
    };

    handleSuggestionsClearRequested = () => {
        this.setState({
            suggestions: [],
        });
    };

    onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {
        this.setState({
            selectedSuggestion: suggestion,
        });
        if (this.props.selectionChanged) {
            this.props.selectionChanged(suggestion);
        }
    };

    handleChange = name => (event, { newValue }) => {
        this.setState({
            [name]: newValue,
            selectedValue: newValue
        });
    };

    render() {
        const { classes, translation } = this.props;

        const autosuggestProps = {
            renderInputComponent,
            suggestions: this.state.suggestions,
            onSuggestionsFetchRequested: this.handleSuggestionsFetchRequested,
            onSuggestionsClearRequested: this.handleSuggestionsClearRequested,
            onSuggestionSelected: this.onSuggestionSelected,
            getSuggestionValue,
            renderSuggestion,
        };

        return (
            <Autosuggest
                {...autosuggestProps}
                inputProps={{
                    classes,
                    t: translation,
                    placeholder: translation('COMMON.MARKET'),
                    selection: this.state.selectedSuggestion,
                    value: this.state.popper,
                    onChange: this.handleChange('popper'),
                    inputRef: node => {
                        this.popperNode = node;
                    },
                    InputLabelProps: {
                        shrink: true,
                    },
                }
                }
                theme={{
                    suggestionsList: classes.suggestionsList,
                    suggestion: classes.suggestion,
                }}
                renderSuggestionsContainer={options => (
                    <Paper
                        {...options.containerProps}
                        className='isoPopOver'>
                        {options.children}
                    </Paper>
                )}
            />
        );
    }
}
IntegrationAutosuggest.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(IntegrationAutosuggest);


// WEBPACK FOOTER //
// ./src/ui/ISOCountryMenu.js